<h2 mat-dialog-title>
    Review For Competency Change Request
    <button class="close-button" (click)="onCancel()" disableRipple>
      <span class="material-symbols-outlined">
        close
        </span>
    </button>
  </h2>
  
  <mat-dialog-content class="mat-typography custom-dialog">
    <div class="employee-info spacing">
      <div class="employee-header">
        <p>
          <strong>{{ data.employee.firstName }} {{ data.employee.lastName }}</strong>
          <span class="requested-date" style="float: right;">• Requested Date: {{ data.employee.requestedDate | date:'dd-MM-yyyy' }}</span>
        </p>
        <p>{{ data.employee.employeeId }} | {{ data.employee.emailAddress || 'No email provided' }}
          <!-- <span *ngIf="data.employee.skills===null || ''" class="skillData" style="float: right;">• {{ data.employee.skills }}</span> -->

        </p>
      </div>
    </div>
  
    <div class="competency-metrics spacing">
      <table>
        <thead>
          <tr>
            <th>Metrics</th>
            <th>Assigned Value</th>
            <th>Requested Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="color: #414141;">Competency</td>
            <td>{{ data.employee.assignedCompetencyName }}</td>
            <td class="requested">{{ data.employee.requestedCompetencyName }}</td>
          </tr>
          <tr class="subcomp">
            <td style="color: #414141;">Sub-Competency</td>
            <td>{{ data.employee.assignedSubCompetencyName }}</td>
            <td class="requested">{{ data.employee.requestedSubCompetencyName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="spacing">
      <strong>Employee Comments:</strong>
      <p>{{ data.employee.comments }}</p>
    </div>
  
    <div class="COE spacing">
      <p>
        <span class="blue-bullet">•</span>
        <strong>COE Lead:</strong>
        <span class="blue-text" *ngIf="data && data.employee && data.employee.coeName">{{ data.employee.coeName }}</span>
        and
        <strong>SubCompetency POC:</strong>
        <span class="blue-text"  *ngIf="data && data.employee && data.employee.subspocNames && data.employee.subspocNames[0]">{{ data.employee.subspocNames[0] }}</span>
        will get notified once the request is accepted or rejected.
      </p>
    </div>
    <div class="line"></div>
  </mat-dialog-content>
  
  <mat-dialog-actions class="review">
    <button class="btn btn-outline btn-spacing" (click)="openConfirmDialog('decline', data.employee)">
      Decline
    </button>
    
    <button class="btn btn-primary" (click)="openConfirmDialog('accept', data.employee)">
      Accept
    </button>
  </mat-dialog-actions>
  
  
  